
import axiosInstance from "../api/axiosInstance";

/* =======================
   BOOKINGS
======================= */

export const getMonthWiseBookings = (clientId, fyid) =>
  axiosInstance.get(
    `/api/dashboard/bookings/month-wise?clientId=${clientId}&fyid=${fyid}`
  );

export const getVehicleGroupWise = (clientId, fyid) =>
  axiosInstance.get(
    `/api/dashboard/bookings/group-wise?clientId=${clientId}&fyid=${fyid}`
  );

export const getPendingSummary = (clientId, fyid) =>
  axiosInstance.get(
    `/api/dashboard/bookings/pending-summary?clientId=${clientId}&fyid=${fyid}`
  );

export const getPendingList = (clientId, fyid, filter = "all") =>
  axiosInstance.get(
    `/api/dashboard/bookings/pending-list?clientId=${clientId}&fyid=${fyid}&filter=${filter}`
  );

/* =======================
   DUTY SUMMARY
======================= */

export const getDutySummary = (clientId, fyid) =>
  axiosInstance.get(
    `/api/dashboard/duties/summary?clientId=${clientId}&fyid=${fyid}`
  );

/* =======================
   DUTY TYPE WISE
======================= */

export const getDutyTypeWise = (clientId, fyid) =>
  axiosInstance.get(
    `/api/dashboard/duties/type-wise?clientId=${clientId}&fyid=${fyid}`
  );

/* =======================
   VEHICLE UTILIZATION
======================= */

export const getVehicleUtilization = (clientId, fyid) =>
  axiosInstance.get(
    `/api/dashboard/duties/vehicle-utilization?clientId=${clientId}&fyid=${fyid}`
  );

/* =======================
   MONTHLY DUTY TREND
======================= */

export const getMonthlyDutyTrend = (clientId, fyid) =>
  axiosInstance.get(
    `/api/dashboard/duties/monthly-trend?clientId=${clientId}&fyid=${fyid}`
  );

/* =======================
   DASHBOARD KPIs
======================= */

export const getDashboardKpis = (clientId, fyid) =>
  axiosInstance.get(
    `/api/dashboard/kpis?clientId=${clientId}&fyid=${fyid}`
  );
